import { useSetAtom } from 'jotai';

import { workspaceInviteDialogAtom } from '~teacher/components/workspaces/InviteWorkspaceDialog/atoms/atoms';

import { WorkspaceRole } from '../../../../../api/workspaces/getWorkspaceMembers';

export function useHandleResetCode({
  workspaceRole,
  canResetInviteLink,
}: {
  canResetInviteLink?: boolean;
  workspaceRole: WorkspaceRole;
}) {
  const dispatch = useSetAtom(workspaceInviteDialogAtom);

  return () => {
    if (!canResetInviteLink) return;

    dispatch({
      type: 'Open',
      payload: {
        memberRole: workspaceRole,
        view: 'ActionOverlayResetLink',
      },
    });
  };
}
